import { render, staticRenderFns } from "./serviceType.vue?vue&type=template&id=0827ddd0&scoped=true&"
import script from "./serviceType.vue?vue&type=script&lang=js&"
export * from "./serviceType.vue?vue&type=script&lang=js&"
import style0 from "./serviceType.vue?vue&type=style&index=0&id=0827ddd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827ddd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
